/* eslint-disable react-hooks/exhaustive-deps */
import { useFormikContext } from "formik";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { listarUnidades } from "../api/General";
import { useCatalog } from "../context/Catalog";
import { useTramite } from "../context/Tramite";
import "./css/components.css";
import { isInvalid } from "../utils/forms";
import { crearSustanciaQuimica } from "../utils/data";
import { isEditable } from "../utils/tramite";
import { useDialog } from "./controls/Dialog";
import Loader from "./controls/Loader";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import QuestionField from "./controls/QuestionField";
import ArrayField from "./controls/ArrayField";
import { SustanciaQuimicaForm } from "./SustanciaQuimicaForm";
import { SustanciaQuimicaList } from "./SustanciaQuimicaList";
import Alert from "./controls/Alert";
import Collapsible from "./controls/Collapsible";

export default function SustanciasQuimicasForm({ ...props }) {
  const { tramite } = useTramite();
  const { t } = useTranslation();
  const tramiteForm = useFormikContext();
  const unidadesCatalog = useCatalog(
    ["unidadesCantidad", "sustanciasQuimicas", "TN", "KG", "M3", "UNIDADES", "L"],
    () =>
      listarUnidades({
        codigo: ["TN", "KG", "M3", "UNIDADES", "L"],
      }),
  );
  const loading = unidadesCatalog.loading;
  const dialog = useDialog({ showing: false, variant: "warning" });
  // const [dialog, setDialog] = useState();
  const handleConQuimicosAuxiliaresChange = (event) => {
    if (
      !event.target.checked &&
      !tramiteForm.values.conQuimicosProduccion &&
      tramiteForm.values.sustanciasQuimicas.length > 0
    ) {
      dialog.display(
        t("messages.tramite.sustanciasQuimicasNotEmpty.title"),
        <p>{t("messages.tramite.sustanciasQuimicasNotEmpty.value")}</p>,
        t("sustanciasQuimicasForm.dialog.accept"),
        t("sustanciasQuimicasForm.dialog.decline"),
        () => {
          tramiteForm.setFieldValue("conQuimicosAuxiliares", false, false);
          tramiteForm.setFieldTouched("conQuimicosAuxiliares", true, true);
          dialog.close();
        },
        () => {
          dialog.close();
        },
      );
    } else {
      tramiteForm.handleChange(event);
    }
  };
  const handleConQuimicosProduccionChange = (event) => {
    if (
      !event.target.checked &&
      !tramiteForm.values.conQuimicosAuxiliares &&
      tramiteForm.values.sustanciasQuimicas.length > 0
    ) {
      dialog.display(
        t("messages.tramite.sustanciasQuimicasNotEmpty.title"),
        t("messages.tramite.sustanciasQuimicasNotEmpty.value"),
        t("sustanciasQuimicasForm.dialog.accept"),
        t("sustanciasQuimicasForm.dialog.decline"),
        () => {
          tramiteForm.setFieldValue("conQuimicosProduccion", false, false);
          tramiteForm.setFieldTouched("conQuimicosProduccion", true, true);
          dialog.close();
        },
        () => {
          dialog.close();
        },
      );
    } else {
      tramiteForm.handleChange(event);
    }
  };
  const handleSustanciasQuimicasChange = (event) => {
    tramiteForm.handleChange(event);
  };
  useEffect(() => {
    if (
      !tramiteForm.values.conQuimicosAuxiliares &&
      !tramiteForm.values.conQuimicosProduccion
    ) {
      tramiteForm.setFieldValue("sustanciasQuimicas", [], false);
      tramiteForm.setFieldTouched("sustanciasQuimicas", true, true);
    }
  }, [
    tramiteForm.values.conQuimicosAuxiliares,
    tramiteForm.values.conQuimicosProduccion,
  ]);
  return (
    <Loader loading={loading}>
      {dialog.component}
      <Alert variant="warning">
        <Collapsible summary={t("sustanciasQuimicasForm.nota.resumen")}>
          <p>{t("sustanciasQuimicasForm.nota.detalle")}</p>
        </Collapsible>
      </Alert>
      <Grid>
        <Row>
          <Col lg={12}>
            <QuestionField
              id="conQuimicosAuxiliares"
              name="conQuimicosAuxiliares"
              label={t("tramite.conQuimicosAuxiliares")}
              value={tramiteForm.values.conQuimicosAuxiliares}
              onChange={handleConQuimicosAuxiliaresChange}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <QuestionField
              id="conQuimicosProduccion"
              name="conQuimicosProduccion"
              label={t("tramite.conQuimicosProduccion")}
              value={tramiteForm.values.conQuimicosProduccion}
              onChange={handleConQuimicosProduccionChange}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <ArrayField
              id="sustanciasQuimicas"
              name="sustanciasQuimicas"
              label={t("tramite.sustanciasQuimicas")}
              value={tramiteForm.values.sustanciasQuimicas}
              onChange={handleSustanciasQuimicasChange}
              createItem={crearSustanciaQuimica}
              isInvalid={isInvalid("sustanciasQuimicas", tramiteForm)}
              error={
                (tramiteForm.errors.sustanciasQuimicas instanceof Array &&
                  t("errors.tramite.sustanciasQuimicas.many")) ||
                t(tramiteForm.errors.sustanciasQuimicas)
              }
              disabled={
                (!tramiteForm.values.conQuimicosAuxiliares &&
                  !tramiteForm.values.conQuimicosProduccion) ||
                !isEditable(tramite)
              }
            >
              {({
                value: sustanciasQuimicas,
                append,
                remove,
                replace,
                select,
                selectedIndex,
                selectedItem,
                disabled,
              }) => (
                <Grid>
                  {!disabled && (
                    <Row>
                      <Col lg={12}>
                        <SustanciaQuimicaForm
                          value={selectedItem}
                          page={selectedIndex}
                          pages={sustanciasQuimicas.length}
                          select={select}
                          append={append}
                          replace={replace}
                          remove={remove}
                          operacionesUnitarias={
                            tramiteForm.values.operacionesUnitarias
                          }
                          unidadesCantidad={unidadesCatalog.data}
                          disabled={disabled}
                        />
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col lg={12}>
                      <SustanciaQuimicaList
                        value={sustanciasQuimicas}
                        select={select}
                        remove={remove}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                </Grid>
              )}
            </ArrayField>
          </Col>
        </Row>
      </Grid>
    </Loader>
  );
}
